/* eslint-disable max-len */
import ContainerPainel from 'components/container_painel';
import React, { useEffect } from 'react';
import { useAuth } from 'contexts/auth/auth_context';
import { usePermissions, ModuleEnum, PermissionType } from 'contexts/auth/permission_context';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import PacoteMunicipalManager from './municipalManager';
import { Box } from '@mui/material';
import { UserPermissionEnum } from 'enum/userPermission.enum';
import PacoteStateManager from './stateManager';

const PacoteFormularios: React.FC = () => {
  const { user } = useAuth();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasPermission(ModuleEnum.FORMS, PermissionType.LIST)) {
      alert('Você não tem permissão para acessar esta página.');
      navigate(ROUTES.HOME);
    }
  }, [hasPermission, navigate]);

  const permissoesPagina = [
    UserPermissionEnum.MUNICIPAL_MANAGER,
  ];

  const temPermissao = permissoesPagina.includes(
    user?.permission?.name as UserPermissionEnum,
  );

  const isStateManager = user?.permission?.name === UserPermissionEnum.STATE_MANAGER || user?.permission?.name === UserPermissionEnum.ADMIN;

  return (
    <ContainerPainel pagina='Gerenciar Formulários' showBackButton={true}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        gap={2}
        alignItems={'center'}
        width={'100%'}
      >
        {temPermissao && (
          <PacoteMunicipalManager user={user!} />
        )}
        {isStateManager && (
          <PacoteStateManager user={user!} />
        )}
      </Box>
    </ContainerPainel>
  );
};

export default PacoteFormularios;
